module.exports = __webpack_public_path__ + "img/logo-02.346deaa1.png";